import React from 'react'
import './HomeHeader.css'

const HomeHeader = ({ stats, loading = false }) => {
  const displayStats = stats || { territories: 0, adventures: 0, characters: 0 }

  return (
    <header className="home-header">
      <div
        className="home-header__bg-map"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/map.jpg)` }}
        aria-hidden="true"
      />
      <div className="home-header__bg-gradient" aria-hidden="true" />
      <div className="home-header__bg-runes" aria-hidden="true" />

      <div className="home-header__content">
        <div className="home-header__brand">
          <div className="home-header__emblem">
            <img src="/assets/images/harima-shinjiru.png" alt="" />
          </div>

          <div className="home-header__text">
            <p className="home-header__script">國 · Mundo · Escuadra</p>
            <h1 className="home-header__title">Shinobis' War</h1>
            <p className="home-header__subtitle">Foro de rol · Territorios y crónicas</p>
            <p className="home-header__description">
              Explora territorios, únete a aventuras y forja tu leyenda en el mundo shinobi.
            </p>
          </div>
        </div>

        <div className="home-header__kpis">
          <div className="home-header__kpi">
            <span className="home-header__kpi-icon">⛩</span>
            <span className="home-header__kpi-value">{loading ? '…' : displayStats.territories}</span>
            <span className="home-header__kpi-label">Territorios</span>
          </div>
          <div className="home-header__kpi-divider" aria-hidden="true">
            ·
          </div>
          <div className="home-header__kpi">
            <span className="home-header__kpi-icon">忍</span>
            <span className="home-header__kpi-value">{loading ? '…' : displayStats.characters}</span>
            <span className="home-header__kpi-label">Shinobis</span>
          </div>
          <div className="home-header__kpi-divider" aria-hidden="true">
            ·
          </div>
          <div className="home-header__kpi">
            <span className="home-header__kpi-icon">⚔</span>
            <span className="home-header__kpi-value">{loading ? '…' : displayStats.adventures}</span>
            <span className="home-header__kpi-label">Aventuras</span>
          </div>
        </div>
      </div>

      <div className="home-header__bottom-border" aria-hidden="true" />
    </header>
  )
}

export default HomeHeader
